// eslint-disable-next-line
import {
  RouteView,
  PageView
} from '@/layouts'

export const platformRouter = [{
  path: '/platform',
  name: 'platform',
  redirect: '/platform/manager/movePort',
  component: RouteView,
  meta: {
    title: '平台',
    keepAlive: true,
    icon: 'shop'
  },
  children: [{
    path: '/platform/manger',
    redirect: '/platform/manager/movePort',
    component: RouteView,
    name:'platformMangerGroup',
    meta: {
      title: '平台管理',
      keepAlive: true,
      icon: 'appstore'
    },
    children: [{
      path: '/platform/manager/movePort',
      name: 'MovePort',
      component: () => import('@/views/platform/manager/MovePort'),
      meta: {
        title: 'H5移动端',
        keepAlive: false
      }
    },
      {
        path: '/platform/manager/officials',
        name: 'Officials',
        component: () => import('@/views/platform/manager/Officials'),
        meta: {
          title: '公众号',
          keepAlive: true
        }
      },
      {
        path: '/platform/manager/applets',
        name: 'Applets',
        component: () => import('@/views/platform/manager/Applets'),
        meta: {
          title: '小程序',
          keepAlive: true
        }
      },
      {
        path: '/platform/manager/pcWeb',
        name: 'PcWeb',
        component: () => import('@/views/platform/manager/PcWeb'),
        meta: {
          title: 'PC网站',
          keepAlive: true
        }
      },
      {
        hidden: true, //不显示在菜单上
        hidePermissionTree: true,//不出现在权限菜单中
        ignorePermissions: true,//忽略权限控制
        path: '/platform/pcWeb/addSlideShow',
        name: 'AddSlideShow',
        component: () => import('@/views/platform/manager/components/AddSlideShow'),
        meta: {
          title: '添加新内容',
          keepAlive: true,
          hideInMenu: true,
          hidePermissionTree: true,
          ignorePermissions: true
        }
      },
      {
        hidden: true, //不显示在菜单上
        hidePermissionTree: true,//不出现在权限菜单中
        ignorePermissions: true,//忽略权限控制
        path: '/platform/pcWeb/addPartner',
        name: 'AddCooperativePartner',
        component: () => import('@/views/platform/manager/components/AddCooperativePartner'),
        meta: {
          title: '添加新伙伴',
          keepAlive: true,
          hideInMenu: true,
          hidePermissionTree: true,
          ignorePermissions: true
        }
      },
      {
        hidden: true, //不显示在菜单上
        hidePermissionTree: true,//不出现在权限菜单中
        ignorePermissions: true,//忽略权限控制
        path: '/platform/pcWeb/addLink',
        name: 'AddLink',
        component: () => import('@/views/platform/manager/components/AddLink'),
        meta: {
          title: '添加友情链接',
          keepAlive: true,
          hideInMenu: true,
          hidePermissionTree: true,
          ignorePermissions: true
        }
      },
      {
        hidden: true, //不显示在菜单上
        hidePermissionTree: true,//不出现在权限菜单中
        ignorePermissions: true,//忽略权限控制
        path: '/platform/pcWeb/addSEO',
        name: 'AddSEOptimization',
        component: () => import('@/views/platform/manager/components/AddSEOptimization'),
        meta: {
          title: '编辑SEO优化',
          keepAlive: true,
          hideInMenu: true,
          hidePermissionTree: true,
          ignorePermissions: true
        }
      },
      {
        hidden: true, //不显示在菜单上
        hidePermissionTree: true,//不出现在权限菜单中
        ignorePermissions: true,//忽略权限控制
        path: '/platform/pcWeb/addNews',
        name: 'AddCompanyNews',
        component: () => import('@/views/platform/manager/components/AddCompanyNews'),
        meta: {
          title: '添加公司新闻',
          keepAlive: true,
          hideInMenu: true,
          hidePermissionTree: true,
          ignorePermissions: true
        }
      },
      {
        hidden: true, //不显示在菜单上
        hidePermissionTree: true,//不出现在权限菜单中
        ignorePermissions: true,//忽略权限控制
        path: '/platform/pcWeb/addPosition',
        name: 'AddPosition',
        component: () => import('@/views/platform/manager/components/AddPosition'),
        meta: {
          title: '添加职位',
          keepAlive: true,
          hideInMenu: true,
          hidePermissionTree: true,
          ignorePermissions: true
        }
      },
      {
        hidden: true, //不显示在菜单上
        hidePermissionTree: true,//不出现在权限菜单中
        ignorePermissions: true,//忽略权限控制
        path: '/platform/pcWeb/editOtherInfo',
        name: 'EditOtherInfo',
        component: () => import('@/views/platform/manager/components/EditOtherInfo'),
        meta: {
          title: '编辑其他',
          keepAlive: true,
          hideInMenu: true,
          hidePermissionTree: true,
          ignorePermissions: true
        }
      }
    ]
  },
    {
      path: '/platform/settings',
      redirect: '/platform/settings/homeSetting',
      component: RouteView,
      name:'homeSettingGroup',
      meta: {
        title: '内容设置',
        keepAlive: true,
        icon: 'appstore'
      },
      children: [
        {
        path: '/platform/settings/homeSetting',
        name: 'HomeSetting',
        component: () => import('@/views/platform/setting/HomeSetting'),
        meta: {
          title: '首页推荐位',
          keepAlive: true
        }
      },
        {
          hidden: true, //不显示在菜单上
          hidePermissionTree: true,//不出现在权限菜单中
          ignorePermissions: true,//忽略权限控制
          path: '/platform/settings/addNewContent',
          name: 'AddNewContent',
          component: () => import('@/views/platform/setting/AddNewContent'),
          meta: {
            title: '添加新内容',
            keepAlive: true,
            hideInMenu: true,
            hidePermissionTree: true,
            ignorePermissions: true
          }
        },
        {
          path: '/platform/settings/homeInlet',
          name: 'HomeInlet',
          component: () => import('@/views/platform/setting/HomeInlet'),
          meta: {
            title: '首页快捷入口',
            keepAlive: true
          }
        },
        {
          hidden: true, //不显示在菜单上
          path: '/platform/settings/addInletContent',
          name: 'AddInletContent',
          component: () => import('@/views/platform/setting/AddInletContent'),
          meta: {
            title: '添加新内容',
            keepAlive: false,
            hideInMenu: true,
            ignorePermissions: true
          },
          ignorePermissions: true
        },
        {
          hidden: true, //不显示在菜单上
          path: '/platform/settings/channelSetting',
          name: 'ChannelSetting',
          component: () => import('@/views/platform/setting/ChannelSetting'),
          meta: {
            title: '频道设置',
            keepAlive: false,
            hideInMenu: true
          }
        },
        {
          hidden: true, //不显示在菜单上
          path: '/platform/settings/department',
          name: 'DepartmentSetting',
          component: () => import('@/views/platform/setting/DepartmentSetting'),
          meta: {
            title: '百货频道设置',
            keepAlive: false,
            hideInMenu: true
          }
        },
        {
          hidden: true, //不显示在菜单上
          path: '/platform/settings/editInletContent',
          name: 'EditInletContent',
          component: () => import('@/views/platform/setting/EditInletContent'),
          meta: {
            title: '编辑内容',
            keepAlive: false,
            hideInMenu: true
          }
        },
        {
          path: '/platform/settings/destination',
          name: 'DestinationList',
          component: () => import('@/views/platform/setting/DestinationList'),
          meta: {
            title: '目的地',
            keepAlive: true
          }
        },
        {
          hidden: true, //不显示在菜单上
          path: '/platform/settings/addDestination',
          name: 'AddDestination',
          component: () => import('@/views/platform/setting/AddDestination'),
          meta: {
            title: '目的地设置',
            keepAlive: true,
            hideInMenu: true
          }
        },
        {
          path: '/platform/settings/clientService',
          name: 'ClientService',
          component: () => import('@/views/platform/setting/ClientService'),
          meta: {
            title: '客服设置',
            keepAlive: false
          }
        }
      ]
    },
    {
      path: '/platform/template',
      redirect: '/platform/template/homeSetting',
      component: RouteView,
      name:'HomeTemplateGroup',
      meta: {
        title: '模版风格',
        keepAlive: true,
        icon: 'appstore'
      },
      children: [
        {
        path: '/platform/template/mine',
        name: 'MyTemplate',
        component: () => import('@/views/platform/template/MyTemplate'),
        meta: {
          title: '我的模版',
          keepAlive: true
        }
      },
        {
          path: '/platform/template/market',
          name: 'Market',
          component: () => import('@/views/platform/template/Market'),
          meta: {
            title: '装修市场',
            keepAlive: true
          }
        }
      ]
    }
  ]
}]